import 'expose-loader?jQuery!jquery-slim';  // eslint-disable-line
import 'expose-loader?$!jquery-slim';  // eslint-disable-line
import 'whatwg-fetch';
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import 'expose-loader?Tether!tether/dist/js/tether';  // eslint-disable-line
import 'bootstrap/dist/js/bootstrap';
import 'react-toastify/dist/ReactToastify.min.css';
import './assets/styles/main.scss';

import {loadSurfaces} from './actions/surfaceActions';
import {loadCategories} from './actions/categoryActions';
import {loadOptions} from './actions/optionActions';
import {loadMatches} from './actions/matchActions';
import {loadProducts} from './actions/productActions';

import configureStore from './store/configureStore';
const store = configureStore();
store.dispatch(loadSurfaces());
store.dispatch(loadOptions());
store.dispatch(loadMatches());
store.dispatch(loadProducts());
store.dispatch(loadCategories());

import ReactGA from 'react-ga';
ReactGA.initialize('UA-107839853-1');

function trackView() {
    ReactGA.set({page: window.location.pathname + window.location.search});
    ReactGA.pageview(window.location.pathname + window.location.search);
}

render(
    <Provider store={store}>
        <Router routes={routes} onUpdate={trackView} history={browserHistory} />
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js